// extracted by mini-css-extract-plugin
export default {"table-layout":"PropertyTable_table-layout__nmT9q","icon-3-dots":"PropertyTable_icon-3-dots__I05mm"};